/* PinnedScrollWidget.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _58 = "@media (min-width:64rem){._gltefl2g{width:calc(52% - 1pc)}._13wnh2mm{position:relative}._180k19lx{inset-block-start:-9pc}._1tnt1v2j{-webkit-margin-after:calc(19% - 87pt);margin-block-end:calc(19% - 87pt)}}";
const _57 = "._4t3i1wug{height:auto}";
const _56 = "._1e0c1ule{display:block}";
const _55 = "._2rko14y2{border-radius:5px}";
const _54 = "._y44v19s7{animation:kgnpaw5 .25s 1}";
const _53 = "._18u01wug{margin-left:auto}";
const _52 = "._otyr1wug{margin-bottom:auto}";
const _51 = "._2hwx1wug{margin-right:auto}";
const _50 = "._19pk1wug{margin-top:auto}";
const _49 = "@keyframes kgnpaw5{0%{opacity:0}to{opacity:1}}";
const _48 = "._u7co15qf{inset-block-end:-10%}";
const _47 = "._1e023ll0{inset-inline-start:-3%}";
const _46 = "._1bsbx19p{width:20%}";
const _45 = "._y44v1gwy{animation:kzqgu5d 1s ease-in-out 1}";
const _44 = "@keyframes kzqgu5d{0%{transform:scale(1)}50%{transform:scale(.9)}to{transform:scale(1)}}";
const _43 = "._y44vk0ur{animation:k5ds9ok 1s ease-in-out 1}";
const _42 = "@keyframes k5ds9ok{0%{transform:scale(.91)}to{transform:scale(1)}}";
const _41 = "._1e02idpf{inset-inline-start:0}";
const _40 = "._kqswstnw{position:absolute}";
const _39 = "._4t3i1osq{height:100%}";
const _38 = "._v564t24z{transition:all 1s}";
const _37 = "._1bsb1osq{width:100%}";
const _36 = "._1h1t15ju{aspect-ratio:7/4}";
const _35 = "._6rth1jfw{-webkit-margin-after:var(--ds-space-500,40px);margin-block-end:var(--ds-space-500,40px)}";
const _34 = "@media not all and (min-width:64rem){._1mjbglyw{display:none}}";
const _33 = "._p12f1mtv{max-width:35.5rem}";
const _32 = "._1tkeidpf{min-height:0}";
const _31 = "._1wpzesu3{align-self:flex-end}";
const _30 = "._1bsb1lko{width:calc(48% - 1pc)}";
const _29 = "._1q51xncg{-webkit-padding-before:var(--ds-space-800,4pc);padding-block-start:var(--ds-space-800,4pc)}";
const _28 = "._kqsw1if8{position:-webkit-sticky;position:sticky}";
const _27 = "._i0dl1nrf{flex-basis:60%}";
const _26 = "._1bah1h6o{justify-content:center}";
const _25 = "._4cvresu3{align-items:flex-end}";
const _24 = "@media (min-width:64rem){._py5ol07h{line-height:1.875rem}}";
const _23 = "._k48p1nn1{font-weight:400}";
const _22 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _21 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _20 = "._y3gn1h6o{text-align:center}";
const _19 = "._18u0idpf{margin-left:0}";
const _18 = "._otyridpf{margin-bottom:0}";
const _17 = "._2hwxidpf{margin-right:0}";
const _16 = "._19pkidpf{margin-top:0}";
const _15 = "._ca0qpxbi{padding-top:var(--ds-space-200,1pc)}";
const _14 = "._2lx21bp4{flex-direction:column}";
const _13 = "._1e0c1txw{display:flex}";
const _12 = "._152tidpf{inset-block-start:0}";
const _11 = "@media not all and (min-width:64rem){._1uby1jfw{margin-bottom:var(--ds-space-500,40px)}}";
const _10 = "@media (min-width:64rem){._13wn1if8{position:-webkit-sticky;position:sticky}._1sbqwebb{top:4.5rem}._hyzqcs5v{z-index:2}._1cfr1vlm{-webkit-clip-path:polygon(0 0,100% 0,100% 100%,53% 100%,53% 32%,0 32%);clip-path:polygon(0 0,100% 0,100% 100%,53% 100%,53% 32%,0 32%)}._4ap31ret{background-color:#f8f8f8}}";
const _9 = "@media not all and (min-width:64rem){._na0i1bp4{flex-direction:column}._1egl10j7{-webkit-margin-after:-40px;margin-block-end:-40px}}";
const _8 = "@media (min-width:64rem){._1tu51w3b .product-type:first-of-type{-webkit-margin-before:-35%;margin-block-start:-35%}._rxoctpnp .product-type:last-child{-webkit-margin-after:-20%;margin-block-end:-20%}}";
const _7 = "._kqswh2mm{position:relative}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Stack } from '@atlaskit/primitives';
/* eslint-disable max-lines-per-function */
import { media } from '@atlaskit/primitives/responsive';
import { BodyLarge, FluidContainer, H3 } from '@atlassian/mpac-primitives';
import React, { useRef, useState } from 'react';
import { HomepageSectionScrollItem } from './ScrollItem';
import { ScrollContext } from './types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _6 = "@media (min-width:64rem) and (max-width:89.99rem){._3vsh1b9w{padding-top:3.75rem}._op2cviql{padding-right:2rem}._gos31b9w{padding-bottom:3.75rem}._50abviql{padding-left:2rem}._yqzznkx7{-webkit-clip-path:polygon(0 3.42%,29.01% 0,53.31% .56%,100% 0,100% 49.48%,100% 74.75%,100% 100%,74.42% 98.98%,50% 99.5%,0 98.98%);clip-path:polygon(0 3.42%,29.01% 0,53.31% .56%,100% 0,100% 49.48%,100% 74.75%,100% 100%,74.42% 98.98%,50% 99.5%,0 98.98%)}}";
const _5 = "@media (min-width:64rem){._oqic1lev{padding-top:5rem}._1rmj172j{padding-right:6.25rem}._cjbt1lev{padding-bottom:5rem}._pnmb172j{padding-left:6.25rem}._1cfrks9y{-webkit-clip-path:polygon(0 7.58%,29.01% 0,53.31% 1.57%,100% 0,100% 49.15%,100% 73.73%,100% 100%,74.4% 97.29%,50% 97.77%,0 97.29%);clip-path:polygon(0 7.58%,29.01% 0,53.31% 1.57%,100% 0,100% 49.15%,100% 73.73%,100% 100%,74.4% 97.29%,50% 97.77%,0 97.29%)}}";
const _4 = "@media (min-width:48rem) and (max-width:63.99rem){._i6jx1b9w{padding-top:3.75rem}._1lh7viql{padding-right:2rem}._z3nc1b9w{padding-bottom:3.75rem}._wpaiviql{padding-left:2rem}._h15znkx7{-webkit-clip-path:polygon(0 3.42%,29.01% 0,53.31% .56%,100% 0,100% 49.48%,100% 74.75%,100% 100%,74.42% 98.98%,50% 99.5%,0 98.98%);clip-path:polygon(0 3.42%,29.01% 0,53.31% .56%,100% 0,100% 49.48%,100% 74.75%,100% 100%,74.42% 98.98%,50% 99.5%,0 98.98%)}}";
const _3 = "@media (min-width:30rem) and (max-width:47.99rem){._ie1c1b9w{padding-top:3.75rem}._78i2viql{padding-right:2rem}._1db01b9w{padding-bottom:3.75rem}._dpmdviql{padding-left:2rem}._1d4lnkx7{-webkit-clip-path:polygon(0 3.42%,29.01% 0,53.31% .56%,100% 0,100% 49.48%,100% 74.75%,100% 100%,74.42% 98.98%,50% 99.5%,0 98.98%);clip-path:polygon(0 3.42%,29.01% 0,53.31% .56%,100% 0,100% 49.48%,100% 74.75%,100% 100%,74.42% 98.98%,50% 99.5%,0 98.98%)}}";
const _2 = "@media not all and (min-width:30rem){._1vlr1b9w{padding-top:3.75rem}._kgiy1k8s{padding-right:1.5rem}._1w0x1b9w{padding-bottom:3.75rem}._958c1k8s{padding-left:1.5rem}._rpom1yoc{-webkit-clip-path:polygon(0 1.36%,29.01% 0,53.31% .58%,100% 0,100% 48.65%,100% 74.6%,100% 99.69%,74.4% 99.46%,50% 100%,0 99.46%);clip-path:polygon(0 1.36%,29.01% 0,53.31% .58%,100% 0,100% 48.65%,100% 74.6%,100% 99.69%,74.4% 99.46%,50% 100%,0 99.46%)}}";
const _ = "._bfhkqbzx{background-color:var(--ds-surface-sunken,#f7f8f9)}";
/* eslint-disable complexity */

const styles = null;
const headingStyles = null;
const subHeadingStyles = null;

// clipPath polygons reused across breakpoints
const clipPathLarge = "0% 7.58%, 29.01% 0%, 53.31% 1.57%, 100% 0%, 100% 49.15%, 100% 73.73%, 100% 100%, 74.4% 97.29%, 50% 97.77%, 0% 97.29%";
const clipPathMediumSet = "0% 3.42%, 29.01% 0%, 53.31% 0.56%, 100% 0%, 100% 49.48%, 100% 74.75%, 100% 100%, 74.42% 98.98%, 50% 99.5%, 0% 98.98%";
const clipPathBelowXs = "0% 1.36%, 29.01% 0%, 53.31% 0.58%, 100% 0%, 100% 48.65%, 100% 74.6%, 100% 99.69%, 74.4% 99.46%, 50% 100%, 0% 99.46%";
const ScrollWidgetContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = FluidContainer,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_bfhkqbzx _1vlr1b9w _kgiy1k8s _1w0x1b9w _958c1k8s _rpom1yoc _ie1c1b9w _78i2viql _1db01b9w _dpmdviql _1d4lnkx7 _i6jx1b9w _1lh7viql _z3nc1b9w _wpaiviql _h15znkx7 _oqic1lev _1rmj172j _cjbt1lev _pnmb172j _1cfrks9y _3vsh1b9w _op2cviql _gos31b9w _50abviql _yqzznkx7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ScrollWidgetContainer.displayName = 'ScrollWidgetContainer';
}
export const ScrollPinnedSections = _ref2 => {
  var _products$0$featureVi, _products$, _products$0$posterIma, _products$2, _products$0$bgShape, _products$3, _products$0$bgColor, _products$4;
  let {
    heading,
    subHeading,
    products,
    onProductCTAClick
  } = _ref2;
  const imgSectionRef = useRef(null);
  const defaultFeatureVideo = (_products$0$featureVi = (_products$ = products[0]) === null || _products$ === void 0 ? void 0 : _products$.featureVideo) !== null && _products$0$featureVi !== void 0 ? _products$0$featureVi : null;
  const defaultFeaturePosterImage = (_products$0$posterIma = (_products$2 = products[0]) === null || _products$2 === void 0 ? void 0 : _products$2.posterImage) !== null && _products$0$posterIma !== void 0 ? _products$0$posterIma : null;
  const defaultBgShape = (_products$0$bgShape = (_products$3 = products[0]) === null || _products$3 === void 0 ? void 0 : _products$3.bgShape) !== null && _products$0$bgShape !== void 0 ? _products$0$bgShape : null;
  const defaultBgColor = (_products$0$bgColor = (_products$4 = products[0]) === null || _products$4 === void 0 ? void 0 : _products$4.bgColor) !== null && _products$0$bgColor !== void 0 ? _products$0$bgColor : null;
  const [activeAccentImg, setActiveAccentImg] = useState(null);
  const [activeColor, setActiveColor] = useState(defaultBgColor);
  const [activeFeatureVideo, setActiveFeatureVideo] = useState(defaultFeatureVideo);
  const [activePosterImage, setActivePosterImage] = useState(defaultFeaturePosterImage);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeShape, setActiveShape] = useState(defaultBgShape);
  const scrollTrackingRef = useRef(null);
  return /*#__PURE__*/_jsx("section", {
    children: /*#__PURE__*/_jsx(ScrollContext.Provider, {
      value: {
        activeAccentImg,
        activeColor,
        activeFeatureVideo,
        activePosterImage,
        activeIndex,
        activeShape,
        setActiveAccentImg,
        setActiveColor,
        setActiveFeatureVideo,
        setActivePosterImage,
        setActiveIndex,
        setActiveShape
      },
      children: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_7, _8]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_kqswh2mm _1tu51w3b _rxoctpnp"]),
          children: /*#__PURE__*/_jsx(ScrollWidgetContainer, {
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_7, _9]
              }), /*#__PURE__*/_jsxs("div", {
                className: ax(["_kqswh2mm _na0i1bp4 _1egl10j7"]),
                children: [/*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_10, _11]
                  }), /*#__PURE__*/_jsx("div", {
                    ref: scrollTrackingRef,
                    className: ax(["_13wn1if8 _1sbqwebb _hyzqcs5v _1cfr1vlm _4ap31ret _1uby1jfw"]),
                    children: /*#__PURE__*/_jsxs(CC, {
                      children: [/*#__PURE__*/_jsx(CS, {
                        children: [_12, _13, _14, _15]
                      }), /*#__PURE__*/_jsxs("div", {
                        className: ax(["_152tidpf _1e0c1txw _2lx21bp4 _ca0qpxbi"]),
                        children: [/*#__PURE__*/_jsxs(Stack, {
                          alignBlock: "center",
                          alignInline: "center",
                          space: "space.100",
                          children: [/*#__PURE__*/_jsxs(CC, {
                            children: [/*#__PURE__*/_jsx(CS, {
                              children: [_16, _17, _18, _19, _20]
                            }), /*#__PURE__*/_jsx(H3, {
                              as: "h2",
                              className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"]),
                              children: heading
                            })]
                          }), /*#__PURE__*/_jsxs(CC, {
                            children: [/*#__PURE__*/_jsx(CS, {
                              children: [_21, _22, _20, _23, _24]
                            }), /*#__PURE__*/_jsx(BodyLarge, {
                              className: ax(["_syaz1fxt _ect418aq _y3gn1h6o _k48p1nn1 _py5ol07h"]),
                              children: subHeading
                            })]
                          })]
                        }), /*#__PURE__*/_jsxs(CC, {
                          children: [/*#__PURE__*/_jsx(CS, {
                            children: [_25, _13, _14, _26, _27, _28, _12, _29, _30, _31, _32, _33, _34]
                          }), /*#__PURE__*/_jsx("div", {
                            ref: imgSectionRef,
                            className: ax(["_4cvresu3 _1e0c1txw _2lx21bp4 _1bah1h6o _i0dl1nrf _kqsw1if8 _152tidpf _1q51xncg _1bsb1lko _1wpzesu3 _1tkeidpf _p12f1mtv _1mjbglyw"]),
                            children: /*#__PURE__*/_jsxs(CC, {
                              children: [/*#__PURE__*/_jsx(CS, {
                                children: [_7, _35, _36, _37]
                              }), /*#__PURE__*/_jsxs("div", {
                                className: ax(["_kqswh2mm _6rth1jfw _1h1t15ju _1bsb1osq"]),
                                children: [activeShape && activeColor && /*#__PURE__*/_jsxs(CC, {
                                  children: [/*#__PURE__*/_jsx(CS, {
                                    children: [_38, _37, _39, _40, _41, _12, _42, _43, _44, _45]
                                  }), /*#__PURE__*/_jsx("div", {
                                    style: {
                                      clipPath: "polygon(".concat(activeShape, ")"),
                                      backgroundColor: activeColor
                                    },
                                    "data-testid": "bg-shape",
                                    className: ax(["_v564t24z _1bsb1osq _4t3i1osq _kqswstnw _1e02idpf _152tidpf", activeIndex % 2 == 0 && "", activeIndex % 2 == 0 && "_y44vk0ur", activeIndex % 2 !== 0 && "", activeIndex % 2 !== 0 && "_y44v1gwy"])
                                  })]
                                }), activeAccentImg && /*#__PURE__*/_jsxs(CC, {
                                  children: [/*#__PURE__*/_jsx(CS, {
                                    children: [_46, _40, _47, _48]
                                  }), /*#__PURE__*/_jsx("div", {
                                    className: ax(["_1bsbx19p _kqswstnw _1e023ll0 _u7co15qf"]),
                                    children: activeAccentImg
                                  })]
                                }), /*#__PURE__*/_jsxs(CC, {
                                  children: [/*#__PURE__*/_jsx(CS, {
                                    children: [_49, _50, _51, _52, _53, _54, _55, _7, _56, _57, _37]
                                  }), /*#__PURE__*/_jsx("video", {
                                    src: activeFeatureVideo !== null && activeFeatureVideo !== void 0 ? activeFeatureVideo : undefined,
                                    poster: activePosterImage !== null && activePosterImage !== void 0 ? activePosterImage : undefined,
                                    loop: false,
                                    autoPlay: true,
                                    muted: true,
                                    playsInline: true,
                                    "data-testid": "feature-video",
                                    className: ax(["_19pk1wug _2hwx1wug _otyr1wug _18u01wug _y44v19s7 _2rko14y2 _kqswh2mm _1e0c1ule _4t3i1wug _1bsb1osq"])
                                  })]
                                })]
                              })]
                            })
                          })]
                        })]
                      })]
                    })
                  })]
                }), /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_58]
                  }), /*#__PURE__*/_jsx("div", {
                    className: ax(["_gltefl2g _13wnh2mm _180k19lx _1tnt1v2j"]),
                    children: products.map((product, index) => /*#__PURE__*/_jsx(HomepageSectionScrollItem, {
                      index: index,
                      productCTA: product.productCTA,
                      header: product.header,
                      description: product.description,
                      featureVideo: product.featureVideo,
                      posterImage: product.posterImage,
                      bgColor: product.bgColor,
                      bgShape: product.bgShape,
                      accentImg: product.accentImg,
                      productName: product.productName,
                      logo: product.logo,
                      keywordsConfig: product.keywordsConfig,
                      onProductCTAClick: onProductCTAClick
                    }, index))
                  })]
                })]
              })]
            })
          })
        })]
      })
    })
  });
};
const fadeIn = null;
const bgShapePulseOdd = null;
const bgShapePulseEven = null;
const rowWidthStyles = null;
const imgSectionStyles = null;
const textSectionStyles = null;
const headerWrapperStyles = null;
const imgRegionStyles = null;
const bgShapeStyles = null;

// dynamic bg styles
const oddBgShapeAnimation = null;
const evenBgShapeAnimation = null;
const imgAccentWrapperStyles = null;
const imgScreenshotStyles = null;
const scrollerStyles = null;